// extracted by mini-css-extract-plugin
export default {"header":"Header_header__+sCR+","divider":"Header_divider__m-Mox","flexColumn":"Header_flexColumn__pFiTi","flexBox":"Header_flexBox__ZoCuQ"};